import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, inject } from "@angular/core";
import { AnchorService } from "./anchor.service";
import { TableModule } from "primeng/table";
import { SkeletonModule } from "primeng/skeleton";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { DialogModule } from "primeng/dialog";
import { HotToastService } from "@ngneat/hot-toast";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ClipboardService } from "ngx-clipboard";
import { TooltipModule } from "primeng/tooltip";
import { DropdownModule } from "primeng/dropdown";
import { BlockUIModule } from "primeng/blockui";
import { SharedDataService } from "src/app/dashboard/shared-data.service";
import { PremiumOverlayDirective } from "src/app/dashboard/premium-overlay.directive";

@Component({
    selector: "app-anchor",
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TableModule,
        SkeletonModule,
        ConfirmDialogModule,
        DialogModule,
        TooltipModule,
        DropdownModule,
        BlockUIModule,
        PremiumOverlayDirective,
    ],
    providers: [ConfirmationService],
    templateUrl: "./anchor.component.html",
    styleUrl: "./anchor.component.css"
})
export class AnchorComponent {
  anchorService = inject(AnchorService);
  cdr = inject(ChangeDetectorRef);
  confirmationService = inject(ConfirmationService);
  toastr = inject(HotToastService);
  clipboardService = inject(ClipboardService);
  sharedDataService = inject(SharedDataService);

  showApiKeyDialog = false;
  keys = [];
  loading = false;
  service = "";

  serviceChoices = [
    { name: "Anchor", value: "anchor" },
    { name: "Zapier", value: "zapier" },
  ];

  rawApiKey = "";

  ngOnInit() {
    this.getAnchorApiKey();
  }

  createApiKey(service) {
    this.anchorService.createApiKey(service.value).then(
      (res) => {
        this.rawApiKey = res.key;
        this.showApiKeyDialog = true;
        this.getAnchorApiKey();
      },
      (err) => {
        console.log(err);
        this.toastr.error("API Key already exists.");
      },
    );
  }

  getAnchorApiKey() {
    this.loading = true;
    this.anchorService.getAnchorApiKey().then((res) => {
      this.keys = res.api_keys;
      this.loading = false;
    });
  }

  deleteApiKey(uuid) {
    this.anchorService.deleteApiKey(uuid).then((res) => {
      this.getAnchorApiKey();
    });
  }

  confirmDelete(uuid) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Are you sure that you want to delete this API Key?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        this.deleteApiKey(uuid);
      },
      reject: () => {},
    });
  }

  toggleDialog() {
    this.showApiKeyDialog = !this.showApiKeyDialog;
  }

  copyAPIKeyToClipboard() {
    this.clipboardService.copy(this.rawApiKey);
    this.toastr.success("API Key copied to clipboard");
  }
}
